<script>
import MvDialog from '@/components/MvDialog/index.vue'

export default {
  name: 'ContactPopup',
  components: { MvDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    handleChange(e) {
      this.$emit('update:visible', e)
    }
  }
}
</script>

<template>
  <mv-dialog
    :visible="visible"
    width="500px"
    :custom-body-style="{
      padding: '0',
      'border-radius': '20px',
      'overflow': 'inherit'
    }"
    :show-close="false"
    :header="false"
    border-radius="20px"
    @change="handleChange"
  >
    <div class="contact-container">
      <div class="inner">
        <div class="body">
          <img class="user" :src="require('@/assets/contact_user.png')">
          <div class="header">
            <div class="titles">
              <div class="bg" />
              <div class="title">添加微信 在线解答</div>
              <div class="sub-title">更加专业、细致的了解</div>
            </div>
          </div>
          <div class="content">
            <div class="qr-code-box">
              <div class="qrcode">
                <img src="/static/wechat.png" style="width: 100%; height: 100%;">
              </div>
            </div>
            <div class="desc">微信扫码添加</div>
          </div>
          <div class="mobile">
            <span class="label">联系电话：</span>
            17711908519、15348994949
          </div>
        </div>
      </div>
    </div>
  </mv-dialog>
</template>

<style scoped lang="scss">

::v-deep .mv-dialog__container {
  background: transparent !important;
}

.inner {
  position: relative;
  background: linear-gradient(180deg, #D5EDFF 0%, #FFFFFF 100%);
  border-radius: 20px;

  .body {
    position: relative;
    width: 100%;
  }

  .header {
    display: flex;
    align-items: center;
    padding-left: 194px;
    padding-top: 25px;
    padding-bottom: 25px;
    position: relative;

    .titles {
      position: relative;
    }

    .bg {
      position: absolute;
      top: 17px;
      left: 0;
      width: 157px;
      height: 20px;
      background: linear-gradient(80deg, #B8DAF4 0%, rgba(184, 228, 244, 0) 100%);
    }

    .title {
      font-weight: 500;
      font-size: 24px;
      color: #064379;
      position: relative;
      z-index: 99;
    }

    .sub-title {
      font-weight: 400;
      font-size: 16px;
      color: #064379;
      padding-top: 10px;
    }
  }

  .user {
    width: 234px;
    height: 180px;
    position: absolute;
    top: -38px;
  }

  .content {
    background: linear-gradient(180deg, #F0FBFF 0%, #FFFFFF 100%);
    border-radius: 20px;
    border: 1px solid #FFFFFF;
    margin: 0 34px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 21px;
    padding-bottom: 17px;
    position: relative;
    z-index: 999;
  }

  .qr-code-box {
    width: 163px;
    height: 163px;
    background: #DDF0FF;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qrcode {
    width: 139px;
    height: 139px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
  }

  .desc {
    font-weight: 500;
    font-size: 18px;
    color: #404040;
    line-height: 25px;
    padding-top: 19px;
  }

  .mobile {
    font-weight: 500;
    font-size: 24px;
    color: #404040;
    line-height: 34px;
    padding-top: 21px;
    text-align: center;
    padding-bottom: 25px;

    .label {
      color: #6D6D6D;
    }
  }
}
</style>
